import ReleaseNotesSection from '@/components/sections/updates/ReleaseNotesSection'
import UpdatesHeroSection from '@/components/sections/updates/UpdatesHeroSection'
import { useData } from '@/hooks/useLocale'
import { useTitle } from '@/hooks/useTitle'

/** The Updates page: a photo hero, then the release notes. */
export default function UpdatesPage() {
  const { UPDATES } = useData()
  useTitle(UPDATES.eyebrow)

  return (
    <>
      <UpdatesHeroSection />
      <ReleaseNotesSection />
    </>
  )
}
